"use client";

import { useRouter } from "next/navigation";
import { Button } from "./button";
import { ChevronLeft } from "lucide-react";

interface BackButtonProps {
  backLink?: string;
  disabled?: boolean;
}

export function BackButton({ backLink, disabled }: BackButtonProps) {
  const router = useRouter();

  const handleBack = () => {
    if (backLink) {
      router.push(backLink);
    } else {
      router.back();
    }
  };

  return (
    <Button
      onClick={disabled ? undefined : handleBack}
      variant='outline'
      className='flex items-center justify-center rounded-full w-8 h-8 p-0'
      disabled={disabled}
    >
      <ChevronLeft
        className={`w-4 h-4 ${disabled ? "text-muted-foreground" : ""}`}
      />
    </Button>
  );
}
